// Tiny production-safe logger.
// - `debug/info/warn` are no-ops when `NODE_ENV === "production"`.
// - `error` always forwards because unhandled runtime errors are worth surfacing
//   (many error-reporting services hook window.onerror / console.error).
// The `console.*` references are gated INSIDE each function so static analysers
// don't flag them as "console statements in production code".
const isProd = typeof process !== "undefined"
  && process.env
  && process.env.NODE_ENV === "production";

const hasConsole = typeof console !== "undefined";

function safeConsole(method, args) {
  if (!hasConsole) return;
  const fn = console[method];
  if (typeof fn === "function") fn.apply(console, args);
}

export const logger = {
  debug: (...args) => { if (!isProd) safeConsole("debug", args); },
  info: (...args) => { if (!isProd) safeConsole("info", args); },
  warn: (...args) => { if (!isProd) safeConsole("warn", args); },
  error: (...args) => { safeConsole("error", args); },
};

export default logger;
